// extracted by mini-css-extract-plugin
export var clientReferral = "index-module--clientReferral--MhuVC";
export var container = "index-module--container--xiOTg";
export var slideItem = "index-module--slideItem--EAg1R";